import React, { useState, useEffect } from 'react';
import './MonteurPlanning.css';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

function MonteurPlanning() {
  const { terms } = useAuth();
  const [werkorders, setWerkorders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVandaag();
  }, []);

  const fetchVandaag = async () => {
    try {
      setLoading(true);
      const response = await api.get('/planning/vandaag');
      console.log('Vandaag response:', response.data);
      setWerkorders(response.data.werkorders || []);
    } catch (error) {
      console.error('Fout bij ophalen planning:', error);
      setWerkorders([]);
    } finally {
      setLoading(false);
    }
  };

  const getPriorityColor = (prioriteit) => {
    switch(prioriteit) {
      case 'urgent': return '#e74c3c';
      case 'hoog': return '#e67e22';
      case 'normaal': return '#3498db';
      case 'laag': return '#95a5a6';
      default: return '#3498db';
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      'nieuw': { label: 'Nieuw', color: '#95a5a6' },
      'toegewezen': { label: 'Toegewezen', color: '#3498db' },
      'in_uitvoering': { label: 'Bezig', color: '#f39c12' },
      'afgerond': { label: 'Afgerond', color: '#27ae60' },
      'geannuleerd': { label: 'Geannuleerd', color: '#e74c3c' }
    };
    return badges[status] || { label: status, color: '#95a5a6' };
  };

  const vandaag = new Date().toLocaleDateString('nl-NL', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  if (loading) {
    return (
      <div className="monteur-planning">
        <div className="loading">Planning laden...</div>
      </div>
    );
  }

  return (
    <div className="monteur-planning">
      <div className="planning-header">
        <h1>📅 Mijn Planning</h1>
        <p className="datum">{vandaag}</p>
      </div>

      {werkorders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🎉</div>
          <h2>Geen werkorders voor vandaag!</h2>
          <p>Je hebt momenteel geen geplande werkorders.</p>
        </div>
      ) : (
        <div className="werkorders-grid">
          {werkorders.map(wo => {
            const statusInfo = getStatusBadge(wo.status);
            return (
              <div
                key={wo.id}
                className="werkorder-card"
                style={{ borderLeftColor: getPriorityColor(wo.prioriteit) }}
              >
                <div className="card-header">
                  <h3>{wo.titel}</h3>
                  <span className="status-badge" style={{ backgroundColor: statusInfo.color }}>
                    {statusInfo.label}
                  </span>
                </div>
                <div className="card-body">
                  {wo.ordernummer && (
                    <div className="info-row">
                      <span className="label">Ordernummer:</span>
                      <span className="value">{wo.ordernummer}</span>
                    </div>
                  )}
                  {wo.klant_naam && (
                    <div className="info-row">
                      <span className="label">{terms?.klant_singular || "Klant"}:</span>
                      <span className="value">{wo.klant_naam}</span>
                    </div>
                  )}
                  {(wo.klant_adres || wo.locatie_adres) && (
                    <div className="info-row">
                      <span className="label">📍 Locatie:</span>
                      <span className="value">{wo.klant_adres || wo.locatie_adres}</span>
                    </div>
                  )}
                  {wo.beschrijving && (
                    <div className="info-row">
                      <span className="label">Beschrijving:</span>
                      <p className="description">{wo.beschrijving}</p>
                    </div>
                  )}
                  <div className="info-row">
                    <span className="label">Prioriteit:</span>
                    <span className="priority-badge" style={{ backgroundColor: getPriorityColor(wo.prioriteit) }}>
                      {wo.prioriteit}
                    </span>
                  </div>
                </div>
                <div className="card-footer">
                  <button className="btn-details" onClick={() => window.location.href = '/werkorder/' + wo.id}>
                    Details bekijken
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MonteurPlanning;
